import React, { useEffect } from "react";
import "./Button.css";
import classNames from "classnames";
import Button from "@mui/material/Button";
import { styled } from "@mui/material";
import ripple from "ripple-effects";


const CustomButton = ({
	clicked,
	children,
	className,
	color = "white",
	bgColor,
	borderRadius = 0,
	border = "",
	width,
	height,
	bgColorOnHover,
	fontSize,
	paddingX = 0,
	paddingY = 0,
	marginX,
	marginY,
	minWidth = 0,
	flex = "unset",
	animationDuration = "0ms",
  }) => {
	const RippleBtn = styled(Button)(({ theme }) => ({
	  color: color,
	  borderRadius: borderRadius,
	  fontSize: fontSize,
	  backgroundColor: bgColor,
	  border: border,
	  width: width,
	  height: height,
	  paddingTop: paddingY,
	  paddingBottom: paddingY,
	  paddingLeft: paddingX,
	  paddingRight: paddingX,
	  marginTop: marginY,
	  marginBottom: marginY,
	  marginLeft: marginX,
	  marginRight: marginX,
	  minWidth: minWidth,
	  flex: flex,
	  aspectRatio: "square",
	  "&:hover": {
		backgroundColor: bgColorOnHover ? bgColorOnHover : bgColor,
	  },
	//   "&:active": {
	// 	transform: "scale(0.95)",
	//   },
	}));
  
	return (
	  <RippleBtn
		sx={{
		  "&& .MuiTouchRipple-rippleVisible": {
			animationDuration: animationDuration,
		  },
		}}
		variant="text"
		onClick={() => clicked()}
		className={className}
	  >
		{children}
	  </RippleBtn>
	);
  };
  

export default CustomButton;
